//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

export const BORDER_STYLE = `${theme.borderWidths[1]} solid ${theme.colors.gray2}`;

export const FETCH_TWEETS_FAILED_ALERT =
  'We failed to fetch your scheduled content. Please try again later or contact Bazaarvoice Support for help.';

const twitterScheduleTrackingPrefix = 'twitter-schedule';

export const TwitterScheduleTrackingIds = {
  EMOJI_PICKER: `${twitterScheduleTrackingPrefix}_emoji-picker`,
  SMART_INPUT: `${twitterScheduleTrackingPrefix}-smart-input`,
  TEXT: `${twitterScheduleTrackingPrefix}_text`,
} as const;
